import React, { useEffect, useId, useState } from 'react';
import axios from 'axios';
import Cookie from "cookie-universal";
import { baseURL, USER } from '../../Api/Api';
import { useNavigate, useParams } from 'react-router-dom';
import TowLocation from '../../Components/location/TowLocation';
import { Form } from 'react-bootstrap';
import { CFormCheck } from '@coreui/react';
import Loading from '../../Components/Loading/Loading';
import ContentHeader from '../../Components/Dashboard/ContentHeader';
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";


export default function OrderDetails() {
  const [data,setData]=useState();
  const[userId,setUserId]=useState();
  const[idInfo,setIdInfo]=useState();
  const[orderNotification,setOrderNotification]=useState('');
  const [orderStatus, setOrderStatus] = useState('accepted');
  const[loading,setLoading]=useState(false);
  const[error,setError]=useState(false);
  
  // get order id
    const {id}=useParams();
  //cookie
  const cookie=Cookie();
  //navigate
  const Nav=useNavigate();
  
  // get cart data
      useEffect(() => {
        setLoading(true);
        try{   axios.get(`${baseURL}/cart`, {
      headers: {
        Authorization: "Bearer " + cookie.get("e-commerce"),
      },
    })
    .then((response) => {
      setData((response.data).filter((item)=>item.id==id)[0]);
      setUserId(((response.data).filter((item)=>item.id==id))[0].user.id);
      setLoading(false);
    })
  }
    catch(err){
     console.log(err)
    }
 
   
  }, []);

  //handle submit
  async function handleSubmit(e){
    setLoading(true);
      e.preventDefault();
          try{
           const res=await axios.put(`${baseURL}/cart/${id}/status`, {
            status: orderStatus,  // e.g., "shipped"
            result: orderStatus==='rejected'?orderNotification:orderStatus==='accepted'?
            'The request has been accepted.':'Your order has been delivered' // optional
            },
            {
            headers: {
                   Authorization: "Bearer " + cookie.get("e-commerce")
            }
          });
          setLoading(false);
          Nav("/dashboard/orders" , {replace:true});
       }
       catch(err){
          console.log(err)
       }
  };
//   // get user details
   useEffect(()=>{
    if(userId)
      setLoading(true);
     axios.get(`${baseURL}/${USER}/${userId}`,{
          headers:{
            Authorization:"Bearer " + cookie.get('e-commerce'),
          }
        }).then((data)=>{setIdInfo(data.data);
          setLoading(false);
        })
        .catch((err)=>
          console.log(err)); 
  },[userId]);
  //mapping data for show in order info
  const dataShow=data?.products.map((item,key)=>{
    return(
      <div key={key} className='details-order-div flex-wrap d-flex justify-content-start align-items-center w-100'>
       <div><h5>{item.product.title}</h5></div>
       <div><h5>price: ${item.product.discount!== "0"?item.product.discount:item.product.price}</h5></div>
        <div><h5>count: {item.count}</h5></div>
        </div>
    );
    });
    const locationData=data?.location.split('-');
    const lat=data?.location.split('-')[0];
    const long=data?.location.split('-')[1];
    

  //reduce  for total count + total price
  const totalCount = data?.products.reduce(
     (acc, pro) => acc + (pro.count || 0),  0);
   const totalPrice = data?.products.reduce((acc, pro) => {
      const price = pro.product ? Number(pro.product.discount!== "0" ? pro.product.discount : pro.product.price) : 0;
      return acc + price.toFixed(2) * (pro.count || 0);
    }, 0);
       //object content header
        const HeaderInfo={
            title:'Order Details',
            icon:faCartShopping,
            BtnName:'Add',
            show:false,
        }

  return (
    <div className='w-100'>
    {loading && <Loading/>}
    <ContentHeader HeaderInfo={HeaderInfo} />
    <div className='p-2' style={{width:'100%'}}>
      {idInfo &&
      <div>
        <div><h4 style={{color:'#0d6efd'}}>User information :</h4> </div>
        <div className='details-order-div d-flex flex-wrap  justify-content-start align-items-center '>
          <div>
            <h5>Name:</h5>
            <h5>{`${idInfo.name}`}</h5>
          </div>
          <div>
            <h5>Email:</h5>
            <h5>{`${idInfo.email}`}</h5>
          </div>
          <div>
            <h5>Contact number:</h5>
            <h5>{`${data.mobile}`}</h5>
          </div>
        </div>
      </div>}
      <div className=' d-flex flex-column justify-content-start align-items-start gap-3 mt-4'>
         <h4 style={{color:'#0d6efd'}}>Order information :</h4>
         {dataShow}
         <div className='details-order-div flex-wrap d-flex justify-content-start
          align-items-center w-100 mt-4'>
          <h5>The total count is: {totalCount}</h5>
          <h5>The total prise is: <span style={{color:'#13bf13'}}>${totalPrice}</span></h5>
         </div>
          {data && <h5 className='mt-4'>the order status is:
             <span style={{color:data.status=='Success'?'#0edd7d':data.status=='accepted'?'var(--primaryColor)'
             :data.status=='rejected'?'red':'black'}}> {data.status}</span></h5>}
      </div>
      {locationData &&
        <div className='mt-4'>
         <h4 style={{color:'#0d6efd'}}>Location information :</h4>
         <div className='details-order-div mt-3 flex-wrap d-flex justify-content-start align-items-center'>
          <h5>latitude:  {locationData[0]}</h5>
          <h5>longitude: {locationData[1]}</h5>
         </div>
        </div>
      }
      {/* get location */}
      <TowLocation lat={lat} long={long} />
         <div className='mt-4'><h4 style={{color:'#0d6efd'}}>Update order status :</h4></div>
         <div className='d-flex flex-wrap gap-3 mt-3'>
        <CFormCheck type="radio" name="flexRadioDefault" id="accepted" label="Accepted"
         checked={orderStatus === 'accepted'} onChange={() => setOrderStatus('accepted')}/>
        <CFormCheck type="radio" name="flexRadioDefault" id="rejected" label="Rejected"
         checked={orderStatus === 'rejected'} onChange={() => setOrderStatus('rejected')}/>
        <CFormCheck type="radio" name="flexRadioDefault" id="Success" label="Success"
         checked={orderStatus === 'Success'} onChange={() => setOrderStatus('Success')}/>
         {error && <p style={{color:'red'}}>Please choose</p>}
        </div>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mt-4" controlId="Notification">
            <Form.Control as="textarea" rows={3}  value={orderNotification}  placeholder="Reason for rejection..."
             onChange={(e)=>setOrderNotification(e.target.value)}  />
        </Form.Group>
        <button className="btn btn-primary mt-3" >Send</button>
      </Form>
    </div>
    </div>
  );
}